import React, { useEffect, useState } from "react";
import Card from "react-bootstrap/Card";
import Slider from "../../atoms/Range/Slider";
import "./timetravelmodel.scss";
import { Icons } from "../../atoms/Icons";
import Buttons from "../../atoms/Buttons";
import Timetravelgif from "../../assets/time-travel.gif";
import loaderImage from "../../assets/loader.png";
import Timetravellogo from "../../assets/svg-icons/time-travel.svg";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../redux/actions";
import {
  addCommas,
  calculateAge,
  calculateDecimalAge,
} from "../../helpers/helpers";
import { ModalOverlay } from "../../atoms/Modal";
import { Link } from "react-router-dom";

const TimeTravelModel = (props) => {
  const [displayGif, setDisplayGif] = useState(true);
  const [saveButton, setSaveButton] = useState(false);
  const [displayPotValue, setDisplayPotValue] = useState(true);
  const [showProcess, setShowProcess] = useState(false);
  const [potValue, setPotValue] = useState(props.estimatedVal);
  const [minYear, setMinYear] = useState();
  const [maxYear, setMaxYear] = useState();
  const [minAge, setMinAge] = useState();
  const [maxAge, setMaxAge] = useState();
  const [age, setAge] = useState(props.newPersonAge);
  const [newRetirementYear] = useState(props.newRetirementYear);
  const [year, setYear] = useState(newRetirementYear);
  const [timeTravelAssumptionModal, setTimeTravelAssumptionModal] =
    useState(false);
  const [isLoaded, setIsLoaded] = useState(true);
  const { calculatePotFetching, calculatePotDataForModal, calculatePotError } =
    useSelector((state) => state.calculateEstimatedPot);
  const {
    fetching: assumptionsFetch,
    data: assumptionsData,
    error: assumptionsError,
  } = useSelector((state) => state.timeTravelAssumptions);
  const dispatch = useDispatch();
  const { calculatePotValue, getTimeTravelAssumptions } = bindActionCreators(
    actionCreators,
    dispatch,
  );
  const [isHovered, setIsHovered] = useState(true);

  const handleMouseEnter = () => {
    setIsHovered(false);
  };
  const handleMouseLeave = () => {
    setIsHovered(true);
  };
  const handleYearRange = (e) => {
    setYear(e.target.value);
    setAge(calculateAgeAtYear(props.timeTravel?.birthDate, e.target.value));
    if (e.target.value == newRetirementYear) {
      setPotValue(props.estimatedVal);
      setDisplayPotValue(true);
      setSaveButton(true);
    } else {
      setDisplayPotValue(false);
      setSaveButton(false);
    }
  };
  const handleAgeRange = (e) => {
    setAge(e.target.value);
    if (e.target.value != minAge) {
      setDisplayPotValue(false);
      setSaveButton(false);
    } else {
      setPotValue(props.initialEstimatedVal);
      setDisplayPotValue(true);
      setSaveButton(false);
    }
  };
  const calculateAgeAtYear = (birthDate, year) => {
    const birthYear = new Date(birthDate).getFullYear();
    return year - birthYear;
  };
  const calculateEstimatedPotValue = () => {
    setIsLoaded(false);
    const activeEmployee = props.investorObject.employmentList?.find(
      (employee) => employee.isRecentActive,
    );
    const dob = new Date(props.timeTravel?.birthDate);
    dob.setMonth(dob.getMonth() - 1);
    const mAge =
      !dob.toString().includes("Invalid Date") &&
      calculateDecimalAge(dob.toISOString().split("T")[0]);
    const payload = {
      investorId: props.investorObject?.investorId,
      investorAccountId: props.investorObject?.accountId,
      currentFundValue: props.totalFund,
      dateOfBirth: props.timeTravel?.birthDate,
      annualSalary: activeEmployee?.salary || 0,
      retirementAge: age,
      retirementDate:
        calculateAge(props?.timeTravel?.birthDate) >
        parseInt(props?.investorObject.retirementAge)
          ? new Date()
              .toISOString()
              .split("T")[0]
              .replace(/^\d{4}/, year)
          : props.investorObject?.retirementDate.replace(/^\d{4}/, year),
      memberAge: mAge,
    };
    calculatePotValue(payload, props.investorObject?.investorId, true);
    setDisplayPotValue(false);
    setShowProcess(true);
    setSaveButton(false);
  };
  useEffect(() => {
    if (
      calculatePotFetching === false &&
      Object.keys(calculatePotDataForModal).length > 0
    ) {
      if (!isLoaded) {
        setPotValue(calculatePotDataForModal?.estFundValueAtPreRetirement);
        setDisplayPotValue(true);
        setShowProcess(false);
        setSaveButton(true);
        setIsLoaded(false);
      }
    }
  }, [calculatePotFetching, calculatePotDataForModal, calculatePotError]);

  const hanleClick = () => {
    sessionStorage.removeItem("timeTravelSavedData");
    let object = {
      potValue: potValue === undefined ? props?.initialEstimatedVal : potValue,
      year: year,
      age: age,
    };
    props.getValue(object);
    props.handleCloseButton();
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDisplayGif(false);
    }, 2000);
    const birthYear = new Date(props.timeTravel?.birthDate).getFullYear();
    const max_Year = birthYear + 75;
    const currentYear = new Date().getFullYear();
    const currentAge = calculateAge(props.timeTravel?.birthDate);
    let min_Year, min_Age;
    if (currentAge <= 55) {
      min_Year = birthYear + 55;
      min_Age = 55;
    } else {
      min_Year = currentYear;
      if (
        minYear !== undefined &&
        maxYear !== undefined &&
        minYear === maxYear
      ) {
        min_Age = currentAge;
      } else if (currentAge === props.personAge) {
        min_Age = currentAge;
      } else {
        min_Age = currentAge + 1;
      }
    }
    {
      setMaxYear(max_Year);
      setMaxAge(75);
    }
    {
      setMinYear(min_Year);
      setMinAge(min_Age);
    }
    return () => clearTimeout(timeout);
  }, []);

  const handleAssumption = () => {
    setTimeTravelAssumptionModal(true);
    if (Object.keys(assumptionsData).length === 0) {
      getTimeTravelAssumptions(props.investorObject?.investorId);
    }
  };

  const handleCloseClick = () => {
    if (typeof props.handleCloseButton === "function") {
      props.handleCloseButton();
    }
  };

  return (
    <div>
      <Card className="time-travel-modal-card">
        <div className="small-close">
          <button
            type="button"
            aria-label="Close time travel model"
            className="btn btn-link p-0"
            onClick={handleCloseClick}
          >
            <Icons iconname="close" variant="icon-sixteen-px" />
          </button>
        </div>
        <Card.Title>
          <div
            className="time-tavel-modal-title"
            onMouseEnter={() => setDisplayGif(true)}
            onMouseLeave={() => setDisplayGif(false)}
          >
            {displayGif ? (
              <img src={Timetravelgif} className="time-travel-gif" />
            ) : (
              <img
                src={Timetravellogo}
                className="time-travel-logo"
                alt="time travel logo"
              />
            )}
            Time travel
          </div>
        </Card.Title>
        <Card.Body>
          <div className="align-center">
            <div className="card-size">
              <div className="slider-container">
                <div
                  className={
                    (minYear == maxYear && age == minAge) ||
                    (minYear != maxYear && year == minYear)
                      ? "value-left-lg d-none d-xl-block d-lg-block d-md-block"
                      : "value-left-sm d-none d-xl-block d-lg-block d-md-block"
                  }
                >
                  {(minYear == maxYear && age == minAge) ||
                  (minYear != maxYear && year == minYear) ? (
                    <div className="age-value d-none d-xl-block d-lg-block d-md-block">
                      Age {minAge}
                    </div>
                  ) : (
                    ""
                  )}
                  <div
                    className={
                      (minYear == maxYear && age == minAge) ||
                      (minYear != maxYear && year == minYear)
                        ? "year-value-lg d-none d-xl-block d-lg-block d-md-block"
                        : "year-value-sm d-none d-xl-block d-lg-block d-md-block"
                    }
                  >
                    {minYear}
                  </div>
                </div>

                <div
                  className={
                    (minYear == maxYear && age == maxAge) ||
                    (minYear != maxYear && year == maxYear)
                      ? "value-right-lg d-none d-xl-block d-lg-block d-md-block"
                      : "value-right-sm d-none d-xl-block d-lg-block d-md-block"
                  }
                >
                  {(minYear == maxYear && age == maxAge) ||
                  (minYear != maxYear && year == maxYear) ? (
                    <div className="age-value d-none d-xl-block d-lg-block d-md-block">
                      Age {maxAge}
                    </div>
                  ) : (
                    ""
                  )}
                  <div
                    className={
                      (minYear == maxYear && age == maxAge) ||
                      (minYear != maxYear && year == maxYear)
                        ? "year-value-lg d-none d-xl-block d-lg-block d-md-block"
                        : "year-value-sm d-none d-xl-block d-lg-block d-md-block"
                    }
                  >
                    {maxYear}
                  </div>
                </div>
              </div>
              {minYear === maxYear ? (
                <Slider
                  onChange={handleAgeRange}
                  value={age}
                  minValue={minAge}
                  maxValue={maxAge}
                  disabled={showProcess}
                  className="time-travel-slider"
                />
              ) : (
                <Slider
                  onChange={handleYearRange}
                  value={year}
                  minValue={minYear}
                  maxValue={maxYear}
                  disabled={showProcess}
                  className="time-travel-slider"
                />
              )}
              <div className="slider-tooltip">
                {minYear == maxYear && age == minAge ? (
                  <div>
                    <div className="container-left d-none d-xl-block d-lg-block d-md-block">
                      <small className="latest-text">
                        This is the <b>earliest</b> you can start your pension
                      </small>
                    </div>
                    <div className="container-middle d-block d-sm-none">
                      <small>
                        This is the <b>earliest</b> you can start your pension
                      </small>
                    </div>
                  </div>
                ) : minYear != maxYear && year == minYear ? (
                  <div>
                    <div className="container-left d-none d-xl-block d-lg-block d-md-block">
                      <small className="latest-text">
                        This is the <b>earliest</b> you can start your pension
                      </small>
                    </div>
                    <div className="container-middle d-block d-sm-none">
                      <small>
                        This is the <b>earliest</b> you can start your pension
                      </small>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {minYear == maxYear && age == maxAge ? (
                  <div>
                    <div className="container-right d-none d-xl-block d-lg-block d-md-block">
                      <small className="latest-text">
                        This is the <b>latest</b> you can start your pension
                      </small>
                    </div>
                    <div className="container-middle d-block d-sm-none">
                      <small>
                        This is the <b>latest</b> you can start your pension
                      </small>
                    </div>
                  </div>
                ) : minYear != maxYear && year == maxYear ? (
                  <div>
                    <div className="container-right d-none d-xl-block d-lg-block d-md-block">
                      <small className="latest-text">
                        This is the <b>latest</b> you can start your pension
                      </small>
                    </div>
                    <div className="container-middle d-block d-sm-none">
                      <small>
                        This is the <b>latest</b> you can start your pension
                      </small>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
              <Card className="child-card">
                <Card.Body>
                  <div className="your-estimate">
                    Your estimated pot value in <span>{year}</span> at age{" "}
                    <span>{age}</span> is...
                  </div>
                  <div className="align-center">
                    {displayPotValue ? (
                      <span className="span-value">
                        £
                        {potValue !== undefined
                          ? addCommas(Math.trunc(potValue))
                          : addCommas(Math.trunc(props?.initialEstimatedVal))}
                        <span className="star">*</span>
                      </span>
                    ) : showProcess ? (
                      <div className="span-value">
                        <img src={loaderImage} className="process-logo" />
                      </div>
                    ) : (
                      <div className="span-value">
                        <Buttons
                          className="secondary"
                          name="Calculate"
                          handleClick={calculateEstimatedPotValue}
                        />
                      </div>
                    )}
                  </div>
                </Card.Body>
              </Card>
              {saveButton ? (
                <div className="save-button">
                  <Buttons
                    className="primary"
                    name="Save to my home"
                    iconname={isHovered ? "arrow-right-white" : "arrow-right"}
                    variantname="icon-sixteen-px"
                    handleClick={hanleClick}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                  />
                </div>
              ) : (
                <div className="empty-div d-none d-xl-block d-lg-block d-md-block"></div>
              )}
            </div>
          </div>
          <div className="container d-none d-xl-block d-lg-block d-md-block">
            <span className="left-span">
              <Link to={"/plan"} className="retirement-link">
                Would you like to change your target retirement age?
              </Link>
            </span>
            <span className="assumption-text right-span">
              *Time travel is based on{" "}
              <button
                type="button"
                className="btn btn-tertiary retirement-link"
                onClick={handleAssumption}
              >
                <b>these assumptions</b>
              </button>
            </span>
          </div>
          <div className="container d-block d-sm-none">
            <div className="assumption-text mb-3">
              *Time travel is based on{" "}
              <button
                type="button"
                className="btn btn-tertiary retirement-link"
                onClick={handleAssumption}
              >
                <b>these assumptions</b>
              </button>
            </div>
            <span>
              <Link to={"/plan"} className="retirement-link">
                Would you like to change your target retirement age?
              </Link>
            </span>
          </div>
        </Card.Body>
      </Card>
      <ModalOverlay
        popup="calculatorAssumptions"
        show={timeTravelAssumptionModal}
        onHide={(e) => {
          if (e !== undefined) {
            e.preventDefault();
          }
          setTimeTravelAssumptionModal(false);
        }}
        modalTitle="Assumptions we’re making"
        assumptionsFetch={assumptionsFetch}
        assumptionsData={assumptionsData}
        assumptionsError={assumptionsError}
        btnGotItHandler={() => setTimeTravelAssumptionModal(false)}
      />
    </div>
  );
};

export default TimeTravelModel;
